import { Dialog, DialogActions, DialogContent, DialogProps, DialogTitle, IconButton, useTheme } from '@mui/material';
import React, { ReactNode } from 'react';
import CloseIcon from '@mui/icons-material/Close';

type CAppDialogProps = DialogProps & {
	actions?: ReactNode;
};

const CAppDialog = (props: CAppDialogProps) => {
	const theme = useTheme();
	return (
		<Dialog {...props} fullWidth maxWidth={props.maxWidth ?? 'md'}>
			{props.title ? (
				<DialogTitle
					style={{
						backgroundColor: theme.palette.mode === 'light' ? '#F3F3F3' : '#1A2B48',
						color: theme.palette.mode === 'light' ? theme.palette.primary.main : '#FFF',
						textAlign: 'center',
						textTransform: 'uppercase',
						letterSpacing: '1px',
						fontSize: '1.25rem',
					}}
				>
					{props.title}
					{props.onClose ? (
						<IconButton
							className="dialog-close-btn"
							onClick={(e) => props?.onClose?.(e, 'backdropClick')}
							sx={{
								position: 'absolute',
								right: 8,
								top: 8,
								color: (theme) => theme.palette.grey[500],
							}}
						>
							<CloseIcon />
						</IconButton>
					) : null}
				</DialogTitle>
			) : (
				''
			)}
			<DialogContent
				style={{
					backgroundColor: theme.palette.mode === 'light' ? '#F3F3F3' : '#1A2B48',
					paddingTop: '20px',
					color: theme.palette.mode === 'light' ? theme.palette.primary.main : '#FFF',
				}}
			>
				{props.children}
			</DialogContent>
			{props.actions ? (
				<DialogActions
					style={{
						backgroundColor: theme.palette.mode === 'light' ? '#F3F3F3' : '#1A2B48',
						color: theme.palette.mode === 'light' ? theme.palette.primary.main : '#FFF',
						justifyContent: 'center',
					}}
				>
					{props.actions}
				</DialogActions>
			) : (
				''
			)}
		</Dialog>
	);
};

export default CAppDialog;
